// Variants barrel export

export {
  LEAD_DROP_POPUP_VARIANTS_CONFIG,
  getLeadDropPopupVariantDetails,
} from "./popup";

export {
  LEAD_DROP_FORM_VARIANTS_CONFIG,
  getLeadDropFormVariantDetails,
} from "./form";

export {
  COURSES_VARIANTS_CONFIG,
  getCourseVariantDetails,
} from "./courses";

export {
  HIGHER_QUALIFICATION_VARIANTS_CONFIG,
  getHigherQualificationVariantDetails,
} from "./higherQualification";

export {
  UNIVERSITY_VARIANTS_CONFIG,
  getUniversityVariantDetails,
} from "./university";

